import React from 'react';
import { AllParticipantsCheck, FormAddGroupContainer, FormAddGroupWrapper } from '../styled-components/groups.styled.components';
import GroupName from './GroupName';
import SelectLeader from './SelectLeader';
import SearchMember from './SearchMember';
import Text from '../../../shared/common/Text';
import { Checkbox, Divider } from '@material-ui/core';
import GridMembers from '../../../shared/common/GridMembers';
import { ButtonFilledDark, ButtonWrapper } from '../../../styled-components/buttons.styled.components';

const FormGroup = props => {
    const {
        handleSubmit,
        handleName,
        group,
        name,
        setLider,
        participants,
        handleSearch,
        search,
        handleAllChecked,
        handleChecked,
        checkedItems,
        loading,
        type,
    } = props;
    const initialValue = {
        participante_id: group?.group_leader_id ?? '',
        nombre: group?.group_leader_name ?? '',
    };

    return (
        <FormAddGroupContainer onSubmit={handleSubmit}>
            <FormAddGroupWrapper>
                <GroupName nombre={name} handleName={handleName} placeholder={group?.nombre} />
                <SelectLeader
                    setLider={setLider}
                    participants={participants}
                    placeholder={'Participante que lidera el grupo'}
                    initialValue={initialValue}
                />
            </FormAddGroupWrapper>
            <FormAddGroupWrapper>
                <SearchMember search={search} handleSearch={handleSearch} />
                <AllParticipantsCheck>
                    <Text fontSize="1rem" fontWeight="700" color="primary">
                        Seleccionar todos
                    </Text>
                    <Checkbox onChange={handleAllChecked} color="primary" />
                </AllParticipantsCheck>
            </FormAddGroupWrapper>

            <GridMembers height="200px" search={search} handleChecked={handleChecked} checkedItems={checkedItems} />
            <Divider />
            <ButtonWrapper alignSelf="flex-end">
                <ButtonFilledDark variant="contained" color="primary" size="small" type="submit" disabled={loading || checkedItems.length === 0}>
                    {type === 'add' ? 'Crear' : 'Guardar cambios'}
                </ButtonFilledDark>
            </ButtonWrapper>
        </FormAddGroupContainer>
    );
};

export default FormGroup;
